import { Action, AnyAction, Store } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { ModerationState } from '../components/moderation-v2/sharable/moderationReducers';
import { IModalState } from '../components/moderation-v2/comments-and-posts/modals';
import { IAccountState } from '../components/account/state';
import { ISettingsState } from '../components/settings/state/types';
import { TenantConfigState } from '../tenant-config/tenantConfigTypes';
import { InitConfigState } from '../init-config/initConfigTypes';
import { ToastState } from '../../components/toast/toastTypes';
import { FeaturesState } from '../../features/featuresTypes';
import { AnalyticsState } from '../../analytics/analyticsTypes';
import { UsersState } from '../../users/usersTypes';
import { CurrentUserState } from '../../current-user/currentUserTypes';
import { SpotSelectorState } from '../../spot-selector/spotSelectorTypes';
import { AuthState } from '../../auth/authTypes';
import { SpotsState } from '../../spots/spotsSlice';

import { INavigationState } from 'app/scripts/components/common/navigation/state';
import { IApplicationState } from 'state/app-state';

export type TAction = Action | ThunkAction<any, TGetState, any, Action>;
export type TDispatch = ThunkDispatch<State, any, AnyAction>;
export type TStore = Store<State, Action> & { dispatch: TDispatch };
export type TGetState = () => State;

export interface State {
  toast: ToastState;
  account: IAccountState;
  auth: AuthState;
  currentUser: CurrentUserState;
  application: IApplicationState;
  navigation: INavigationState;
  modals: IModalState;
  moderation: ModerationState;
  analytics: AnalyticsState;
  viewConversation: any;
  settings: ISettingsState;
  features: FeaturesState;
  tenantConfig: TenantConfigState;
  initConfig: InitConfigState;
  users: UsersState;
  spotSelector: SpotSelectorState;
  spots: SpotsState;
}

export const useTypedSelector: TypedUseSelectorHook<State> = useSelector;
